module.exports = __webpack_public_path__ + "static/media/icon-face-to-face.9ba2f9a3.svg";